import React from 'react';
import { Field, reduxForm, stopSubmit, formValueSelector } from 'redux-form';
import { Form, FormGroup, Label, Alert } from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import SelectDropdown from '../../system/fields/SelectDropdown';
import FileUpload from '../../system/fields/FileUpload';
import StarRating from '../../system/fields/StarRating';

import * as validations from '../../system/utils/Validation';
import { connect } from 'react-redux';

let EditForm = (props, { fields }) => {
    const { handleSubmit, mode } = props;
    return (
        <section className='edit-form'>
            <Form onSubmit={handleSubmit}>
                <section className='form-section'>
                    <div className='form-section-header'>Category</div>

                    <div className='row'>
                        <FormGroup className='col-12 col-sm-6'>
                            <Label htmlFor='email'>Category Name</Label>
                            <Field
                                name='name'
                                component={TextInput}
                                placeholder='Name'
                                type='text'
                                validate={validations.required}
                                autoFocus={true}
                            />
                        </FormGroup>
                    </div>
                </section>
            </Form>

            {props.submitFailed && (
                <div className='error-container'>
                    <Alert color='danger'>
                        <strong>There are errors in your form.</strong>
                        <br />
                        Please check before submitting again.
                    </Alert>
                </div>
            )}
        </section>
    );
};

EditForm = reduxForm({
    form: 'ActivityCategories',
    onChange: (values, dispatch, props) => {
        if (props.error || props.submitFailed) {
            dispatch(stopSubmit('ActivityCategories'));
        }
    },
})(EditForm);

const selector = formValueSelector('ActivityCategories');

const mapStateToProps = (state) => ({
    featured: selector(state, 'featured'),
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityCategories/Form.jsx